module.exports = __webpack_public_path__ + "img/background2.9d5b1043.jpg";